import type { SiteI18n } from "../site-types";

const ru: SiteI18n = {
  seo: {
    title: "Аренда авто в Бишкеке | Прокат машин, SUV и трансфер Манас | Freeways",
    description:
      "Аренда авто в Бишкеке от Freeways: прокат машин без водителя, внедорожники и SUV, премиум авто BMW, Mercedes, Lexus, трансфер из аэропорта Манас и поездки по Кыргызстану.",
  },
  hero: {
    h1: "Аренда авто в Бишкеке и по Кыргызстану",
    subtitle:
      "Freeways — прокат автомобилей от эконом- до премиум-класса для поездок по Бишкеку, трансфера из аэропорта Манас, свадеб, деловых встреч и путешествий по Кыргызстану.",
    cta: "Забронировать авто",
  },
  services: {
    title: "Наши услуги",
    items: [
      { title: "Аренда авто без водителя", desc: "Свободные поездки по Бишкеку и Кыргызстану на любой срок." },
      { title: "Аренда авто с водителем", desc: "Опытные водители для деловых поездок и трансфера." },
      { title: "Премиум авто", desc: "Mercedes, BMW, Lexus для важных встреч и особых событий." },
      { title: "Внедорожники и SUV", desc: "Надёжные автомобили для гор, Иссык-Куля и дальних поездок." },
      { title: "Трансфер аэропорт Манас", desc: "Встреча и доставка в аэропорт в любое время суток." },
      { title: "Авто на свадьбу", desc: "Премиальные автомобили с украшением для свадебного кортежа." },
      { title: "Туры и джип-туры по Кыргызстану", desc: "Маршруты по горам, ущельям и озёрам страны." },
    ],
  },
  categories: {
    title: "Категории автомобилей",
    items: ["Эконом авто", "Комфорт-класс", "Бизнес-класс", "Премиум авто", "Внедорожники", "Минивэны", "Авто с водителем"],
  },
  advantages: {
    title: "Почему выбирают Freeways",
    items: [
      "Быстрое оформление аренды",
      "Чистые и ухоженные автомобили",
      "Аренда с водителем и без",
      "Авто для города, гор и дальних поездок",
      "Трансфер из аэропорта Манас",
      "Поездки по Бишкеку, Иссык-Кулю и Кыргызстану",
    ],
  },
  faq: {
    title: "Часто задаваемые вопросы",
    description: "Ответы об аренде авто в Бишкеке, документах, страховке и поездках по Кыргызстану.",
    items: [
      { q: "Какие документы нужны для аренды авто?", a: "Нужны паспорт и водительское удостоверение. Стаж от 2 лет и возраст от 23 лет." },
      { q: "Можно ли арендовать авто без водителя?", a: "Да, аренда без водителя доступна на любой срок — от суток до нескольких месяцев." },
      { q: "Есть ли аренда авто с водителем?", a: "Да, предоставляем опытных водителей для города, трансфера и междугородних поездок." },
      { q: "Можно ли заказать трансфер из аэропорта Манас?", a: "Да, организуем встречу и доставку из аэропорта Манас 24/7." },
      { q: "Можно ли поехать на Иссык-Куль?", a: "Да, наши автомобили подходят для поездок на Иссык-Куль и по всему Кыргызстану." },
      { q: "Есть ли внедорожники для горных маршрутов?", a: "Да, в парке есть SUV и внедорожники для гор и бездорожья." },
      { q: "Можно ли арендовать авто на свадьбу?", a: "Да, премиум-авто с украшением — для свадебного кортежа и торжественных событий." },
      { q: "Есть ли долгосрочная аренда авто?", a: "Да, действуют скидки от 5 и от 10 дней; долгие сроки обсуждаются индивидуально." },
    ],
  },
  carCardSeo: (m) =>
    `Аренда ${m} в Бишкеке — удобный автомобиль для поездок по городу, трансфера, деловых встреч и путешествий по Кыргызстану. Доступна аренда с водителем и без водителя.`,
  carAlt: (m) => `Аренда ${m} в Бишкеке — Freeways`,
  servicesKeywords:
    "Прокат авто в Бишкеке: эконом, комфорт, бизнес-класс, премиум авто, внедорожники, трансфер из аэропорта Манас, аренда с водителем, поездки на Иссык-Куль, джип-туры по Кыргызстану, авто на свадьбу.",
};

export const keywords = "аренда авто Бишкек, прокат авто Бишкек, аренда машин Бишкек, аренда авто Кыргызстан, прокат автомобилей Бишкек, аренда авто без водителя Бишкек, аренда авто с водителем Бишкек, прокат авто без водителя, аренда авто дёшево Бишкек, аренда авто посуточно Бишкек, аренда авто на сутки, аренда авто на длительный срок, премиум авто Бишкек, аренда внедорожников Бишкек, аренда SUV Бишкек, аренда бизнес авто Бишкек, аренда минивэна Бишкек, аренда Toyota Camry Бишкек, аренда BMW Бишкек, аренда Mercedes Бишкек, аренда Lexus Бишкек, аренда Hyundai Бишкек, трансфер аэропорт Манас, такси Манас Бишкек, аренда авто на свадьбу Бишкек, аренда авто на Иссык-Куль, поездка на Иссык-Куль авто, джип-тур Кыргызстан, тур по Кыргызстану на авто, прокат авто аэропорт Манас, rent a car Bishkek, car rental Kyrgyzstan, Freeways автопрокат";
export const longSeo = "Freeways — компания по аренде авто в Бишкеке и Кыргызстане. Мы предлагаем прокат автомобилей эконом, комфорт, бизнес и премиум класса, аренду авто без водителя и с водителем, внедорожники и SUV для поездок по горам, минивэны для семьи и групп. Организуем трансфер из аэропорта Манас 24/7, поездки на Иссык-Куль, в Чолпон-Ату, Каракол, Ош и Талас, а также джип-туры по Ала-Арче, Чункурчаку, Сары-Челеку и Сон-Кулю. Подаём авто в любую точку Бишкека и Кыргызстана, оформляем посуточную и долгосрочную аренду с прозрачным договором и страховкой.";
const data: SiteI18n = { ...ru, keywords, longSeo };
export default data;
